import type { VisitConsentConfirmPayload } from "../../hooks/Remote/Schedule/visit-consent-confirm.api";
import type { VisitConsentConfirmResponse } from "../../hooks/Remote/Schedule/visit-consent-public.api";
import { mapVisitConsentPublicErrorKey } from "./visit-consent-public-error.map";

export type VisitorConsentHandleNextDeps = {
  setSubmitError: (value: string | null) => void;
  isIntroPage: boolean;
  documentListLength: number;
  setIsIntroPage: (value: boolean) => void;
  currentDocumentIndex: number;
  setCurrentDocumentIndex: (updater: (prev: number) => number) => void;
};

export function visitorConsentHandleNext(deps: VisitorConsentHandleNextDeps): void {
  deps.setSubmitError(null);

  if (deps.isIntroPage) {
    if (deps.documentListLength === 0) {
      return;
    }
    deps.setIsIntroPage(false);
    return;
  }

  if (deps.currentDocumentIndex < deps.documentListLength - 1) {
    deps.setCurrentDocumentIndex(prev => prev + 1);
  }
}

export type VisitorConsentHandleConfirmDeps = {
  setSubmitError: (value: string | null) => void;
  pendingConfirmPayload: VisitConsentConfirmPayload | null;
  mutateAsync: (payload: VisitConsentConfirmPayload) => Promise<VisitConsentConfirmResponse>;
  t: (key: string) => string;
  onSuccess: () => void;
};

export async function visitorConsentHandleConfirm(
  deps: VisitorConsentHandleConfirmDeps
): Promise<void> {
  deps.setSubmitError(null);

  if (!deps.pendingConfirmPayload) {
    return;
  }

  try {
    const result = await deps.mutateAsync(deps.pendingConfirmPayload);
    if (result.consentStatus === "complete") {
      deps.onSuccess();
    }
  } catch (error: unknown) {
    deps.setSubmitError(deps.t(mapVisitConsentPublicErrorKey(error)));
  }
}
